// Generated from CustomAxisParser.g4 by ANTLR 4.8
// jshint ignore: start
import antlr4 from 'antlr4/index';

var grammarFileName = "CustomAxisParser.g4";


var serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
    "\u0003\u0013^\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004\t",
    "\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t\u0007\u0004",
    "\b\t\b\u0003\u0002\u0003\u0002\u0003\u0002\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0005\u00030\n\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0007\u00038\n\u0003\f\u0003",
    "\u000e\u0003;\u000b\u0003\u0003\u0004\u0003\u0004\u0003\u0004\u0003",
    "\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0005\u0003\u0005\u0003",
    "\u0005\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0005\u0005\u0005K",
    "\n\u0005\u0003\u0005\u0003\u0005\u0003\u0006\u0005\u0006P\n\u0006\u0003",
    "\u0006\u0003\u0006\u0003\u0007\u0003\u0007\u0003\u0007\u0007\u0007W",
    "\n\u0007\f\u0007\u000e\u0007Z\u000b\u0007\u0003\b\u0003\b\u0003\b\u0002",
    "\u0003\u0004\t\u0002\u0004\u0006\b\n\f\u000e\u0002\u0002\u0002d\u0002",
    "\u0010\u0003\u0002\u0002\u0002\u0004/\u0003\u0002\u0002\u0002\u0006",
    "<\u0003\u0002\u0002\u0002\bC\u0003\u0002\u0002\u0002\nO\u0003\u0002",
    "\u0002\u0002\fS\u0003\u0002\u0002\u0002\u000e[\u0003\u0002\u0002\u0002",
    "\u0010\u0011\u0005\u0004\u0003\u0002\u0011\u0012\u0007\u0002\u0002\u0003",
    "\u0012\u0003\u0003\u0002\u0002\u0002\u0013\u0014\b\u0003\u0001\u0002",
    "\u0014\u0015\u0007\u0004\u0002\u0002\u00150\u0005\u0004\u0003\u000e",
    "\u0016\u0017\u0007\u0005\u0002\u0002\u0017\u0018\u0005\u0004\u0003\u0002",
    "\u0018\u0019\u0007\u0006\u0002\u0002\u00190\u0003\u0002\u0002\u0002",
    "\u001a\u001b\u0007\b\u0002\u0002\u001b\u001c\u0007\u0005\u0002\u0002",
    "\u001c\u001d\u0005\u0004\u0003\u0002\u001d\u001e\u0007\u0006\u0002\u0002",
    "\u001e0\u0003\u0002\u0002\u0002\u001f \u0007\t\u0002\u0002 !\u0007\u0005",
    "\u0002\u0002!\"\u0005\f\u0007\u0002\"#\u0007\u0006\u0002\u0002#0\u0003",
    "\u0002\u0002\u0002$%\u0007\r\u0002\u0002%&\u0007\u0005\u0002\u0002&",
    "0\u0007\u0006\u0002\u0002\'0\u0007\u000e\u0002\u0002(0\u0007\f\u0002",
    "\u0002)*\u0007\u000f\u0002\u0002*+\u0005\u000e\b\u0002+,\u0007\u0012",
    "\u0002\u0002,0\u0003\u0002\u0002\u0002-0\u0005\u0006\u0004\u0002.0\u0005",
    "\b\u0005\u0002/\u0013\u0003\u0002\u0002\u0002/\u0016\u0003\u0002\u0002",
    "\u0002/\u001a\u0003\u0002\u0002\u0002/\u001f\u0003\u0002\u0002\u0002",
    "/$\u0003\u0002\u0002\u0002/\'\u0003\u0002\u0002\u0002/(\u0003\u0002",
    "\u0002\u0002/)\u0003\u0002\u0002\u0002/-\u0003\u0002\u0002\u0002/.\u0003",
    "\u0002\u0002\u000209\u0003\u0002\u0002\u000212\f\r\u0002\u000223\u0007",
    "\u0003\u0002\u000238\u0005\u0004\u0003\u000e45\f\f\u0002\u000256\u0007",
    "\u0004\u0002\u000268\u0005\u0004\u0003\r71\u0003\u0002\u0002\u00027",
    "4\u0003\u0002\u0002\u00028;\u0003\u0002\u0002\u000297\u0003\u0002\u0002",
    "\u00029:\u0003\u0002\u0002\u0002:\u0005\u0003\u0002\u0002\u0002;9\u0003",
    "\u0002\u0002\u0002<=\u0007\n\u0002\u0002=>\u0007\u0005\u0002\u0002>",
    "?\u0007\u000f\u0002\u0002?@\u0005\u000e\b\u0002@A\u0007\u0012\u0002",
    "\u0002AB\u0007\u0006\u0002\u0002B\u0007\u0003\u0002\u0002\u0002CD\u0007",
    "\u000b\u0002\u0002DE\u0007\u0005\u0002\u0002EF\u0007\u000f\u0002\u0002",
    "FG\u0005\u000e\b\u0002GJ\u0007\u0012\u0002\u0002HI\u0007\u0007\u0002",
    "\u0002IK\u0005\n\u0006\u0002JH\u0003\u0002\u0002\u0002JK\u0003\u0002",
    "\u0002\u0002KL\u0003\u0002\u0002\u0002LM\u0007\u0006\u0002\u0002M\t",
    "\u0003\u0002\u0002\u0002NP\u0007\u0004\u0002\u0002ON\u0003\u0002\u0002",
    "\u0002OP\u0003\u0002\u0002\u0002PQ\u0003\u0002\u0002\u0002QR\u0007\u000e",
    "\u0002\u0002R\u000b\u0003\u0002\u0002\u0002SX\u0005\u0004\u0003\u0002",
    "TU\u0007\u0007\u0002\u0002UW\u0005\u0004\u0003\u0002VT\u0003\u0002\u0002",
    "\u0002WZ\u0003\u0002\u0002\u0002XV\u0003\u0002\u0002\u0002XY\u0003\u0002",
    "\u0002\u0002Y\r\u0003\u0002\u0002\u0002ZX\u0003\u0002\u0002\u0002[\\",
    "\u0007\u0011\u0002\u0002\\\u000f\u0003\u0002\u0002\u0002\b/79JOX"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

var sharedContextCache = new antlr4.PredictionContextCache();

var literalNames = [ null, null, null, "'('", "')'", "','", null, null, 
                     "'completion'", "'attr'", "'step'", null, null, "'${'", 
                     null, null, "'}'" ];

var symbolicNames = [ null, "MULTIPLY_OPERATORS", "ADDITION_OPERATORS", 
                      "BEGIN_PARENTHESIS", "END_PARENTHESIS", "COMMA", "FUNCTION", 
                      "VARIADIC_FUNCTION", "COMPLETION_FUNCTION", "RUN_ATTRIBUTE_FUNCTION", 
                      "STEP", "NAMED_CONSTANT", "NUMBER_LITERAL", "BEGIN_SUBSTITUTION", 
                      "WS", "ATTRIBUTE_NAME", "END_SUBSTITUTION", "WS2" ];

var ruleNames =  [ "formula", "expr", "completionFunction", "runAttributeFunction", 
                   "runAttributeDefault", "argumentList", "attributeName" ];

function CustomAxisParser (input) {
	antlr4.Parser.call(this, input);
    this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
    this.ruleNames = ruleNames;
    this.literalNames = literalNames;
    this.symbolicNames = symbolicNames;
    return this;
}

CustomAxisParser.prototype = Object.create(antlr4.Parser.prototype);
CustomAxisParser.prototype.constructor = CustomAxisParser;

Object.defineProperty(CustomAxisParser.prototype, "atn", {
	get : function() {
		return atn;
	}
});

CustomAxisParser.EOF = antlr4.Token.EOF;
CustomAxisParser.MULTIPLY_OPERATORS = 1;
CustomAxisParser.ADDITION_OPERATORS = 2;
CustomAxisParser.BEGIN_PARENTHESIS = 3;
CustomAxisParser.END_PARENTHESIS = 4;
CustomAxisParser.COMMA = 5;
CustomAxisParser.FUNCTION = 6;
CustomAxisParser.VARIADIC_FUNCTION = 7;
CustomAxisParser.COMPLETION_FUNCTION = 8;
CustomAxisParser.RUN_ATTRIBUTE_FUNCTION = 9;
CustomAxisParser.STEP = 10;
CustomAxisParser.NAMED_CONSTANT = 11;
CustomAxisParser.NUMBER_LITERAL = 12;
CustomAxisParser.BEGIN_SUBSTITUTION = 13;
CustomAxisParser.WS = 14;
CustomAxisParser.ATTRIBUTE_NAME = 15;
CustomAxisParser.END_SUBSTITUTION = 16;
CustomAxisParser.WS2 = 17;

CustomAxisParser.RULE_formula = 0;
CustomAxisParser.RULE_expr = 1;
CustomAxisParser.RULE_completionFunction = 2;
CustomAxisParser.RULE_runAttributeFunction = 3;
CustomAxisParser.RULE_runAttributeDefault = 4;
CustomAxisParser.RULE_argumentList = 5;
CustomAxisParser.RULE_attributeName = 6;


function FormulaContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = CustomAxisParser.RULE_formula;
    return this;
}

FormulaContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
FormulaContext.prototype.constructor = FormulaContext;

FormulaContext.prototype.expr = function() {
    return this.getTypedRuleContext(ExprContext,0);
};

FormulaContext.prototype.EOF = function() {
    return this.getToken(CustomAxisParser.EOF, 0);
};




CustomAxisParser.FormulaContext = FormulaContext;

CustomAxisParser.prototype.formula = function() {

    var localctx = new FormulaContext(this, this._ctx, this.state);
    this.enterRule(localctx, 0, CustomAxisParser.RULE_formula);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 14;
        this.expr(0);
        this.state = 15;
        this.match(CustomAxisParser.EOF);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ExprContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = CustomAxisParser.RULE_expr;
    return this;
}

ExprContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ExprContext.prototype.constructor = ExprContext;

ExprContext.prototype.ADDITION_OPERATORS = function() {
    return this.getToken(CustomAxisParser.ADDITION_OPERATORS, 0);
};

ExprContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};

ExprContext.prototype.BEGIN_PARENTHESIS = function() {
    return this.getToken(CustomAxisParser.BEGIN_PARENTHESIS, 0);
};

ExprContext.prototype.END_PARENTHESIS = function() {
    return this.getToken(CustomAxisParser.END_PARENTHESIS, 0);
};

ExprContext.prototype.FUNCTION = function() {
    return this.getToken(CustomAxisParser.FUNCTION, 0);
};

ExprContext.prototype.VARIADIC_FUNCTION = function() {
    return this.getToken(CustomAxisParser.VARIADIC_FUNCTION, 0);
};

ExprContext.prototype.argumentList = function() {
    return this.getTypedRuleContext(ArgumentListContext,0);
};

ExprContext.prototype.NAMED_CONSTANT = function() {
    return this.getToken(CustomAxisParser.NAMED_CONSTANT, 0);
};

ExprContext.prototype.NUMBER_LITERAL = function() {
    return this.getToken(CustomAxisParser.NUMBER_LITERAL, 0);
};

ExprContext.prototype.STEP = function() {
    return this.getToken(CustomAxisParser.STEP, 0);
};

ExprContext.prototype.BEGIN_SUBSTITUTION = function() {
    return this.getToken(CustomAxisParser.BEGIN_SUBSTITUTION, 0);
};

ExprContext.prototype.attributeName = function() {
    return this.getTypedRuleContext(AttributeNameContext,0);
};

ExprContext.prototype.END_SUBSTITUTION = function() {
    return this.getToken(CustomAxisParser.END_SUBSTITUTION, 0);
};

ExprContext.prototype.completionFunction = function() {
    return this.getTypedRuleContext(CompletionFunctionContext,0);
};

ExprContext.prototype.runAttributeFunction = function() {
    return this.getTypedRuleContext(RunAttributeFunctionContext,0);
};

ExprContext.prototype.MULTIPLY_OPERATORS = function() {
    return this.getToken(CustomAxisParser.MULTIPLY_OPERATORS, 0);
};



CustomAxisParser.prototype.expr = function(_p) {
	if(_p===undefined) {
	    _p = 0;
	}
    var _parentctx = this._ctx;
    var _parentState = this.state;
    var localctx = new ExprContext(this, this._ctx, _parentState);
    var _prevctx = localctx;
    var _startState = 2;
    this.enterRecursionRule(localctx, 2, CustomAxisParser.RULE_expr, _p);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 45;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case CustomAxisParser.ADDITION_OPERATORS:
            this.state = 18;
            this.match(CustomAxisParser.ADDITION_OPERATORS);
            this.state = 19;
            this.expr(12);
            break;
        case CustomAxisParser.BEGIN_PARENTHESIS:
            this.state = 20;
            this.match(CustomAxisParser.BEGIN_PARENTHESIS);
            this.state = 21;
            this.expr(0);
            this.state = 22;
            this.match(CustomAxisParser.END_PARENTHESIS);
            break;
        case CustomAxisParser.FUNCTION:
            this.state = 24;
            this.match(CustomAxisParser.FUNCTION);
            this.state = 25;
            this.match(CustomAxisParser.BEGIN_PARENTHESIS);
            this.state = 26;
            this.expr(0);
            this.state = 27;
            this.match(CustomAxisParser.END_PARENTHESIS);
            break;
        case CustomAxisParser.VARIADIC_FUNCTION:
            this.state = 29;
            this.match(CustomAxisParser.VARIADIC_FUNCTION);
            this.state = 30;
            this.match(CustomAxisParser.BEGIN_PARENTHESIS);
            this.state = 31;
            this.argumentList();
            this.state = 32;
            this.match(CustomAxisParser.END_PARENTHESIS);
            break;
        case CustomAxisParser.NAMED_CONSTANT:
            this.state = 34;
            this.match(CustomAxisParser.NAMED_CONSTANT);
            this.state = 35;
            this.match(CustomAxisParser.BEGIN_PARENTHESIS);
            this.state = 36;
            this.match(CustomAxisParser.END_PARENTHESIS);
            break;
        case CustomAxisParser.NUMBER_LITERAL:
            this.state = 37;
            this.match(CustomAxisParser.NUMBER_LITERAL);
            break;
        case CustomAxisParser.STEP:
            this.state = 38;
            this.match(CustomAxisParser.STEP);
            break;
        case CustomAxisParser.BEGIN_SUBSTITUTION:
            this.state = 39;
            this.match(CustomAxisParser.BEGIN_SUBSTITUTION);
            this.state = 40;
            this.attributeName();
            this.state = 41;
            this.match(CustomAxisParser.END_SUBSTITUTION);
            break;
        case CustomAxisParser.COMPLETION_FUNCTION:
            this.state = 43;
            this.completionFunction();
            break;
        case CustomAxisParser.RUN_ATTRIBUTE_FUNCTION:
            this.state = 44;
            this.runAttributeFunction();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
        this._ctx.stop = this._input.LT(-1);
        this.state = 55;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,2,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                if(this._parseListeners!==null) {
                    this.triggerExitRuleEvent();
                }
                _prevctx = localctx;
                this.state = 53;
                this._errHandler.sync(this);
                var la_ = this._interp.adaptivePredict(this._input,1,this._ctx);
                switch(la_) {
                case 1:
                    localctx = new ExprContext(this, _parentctx, _parentState);
                    this.pushNewRecursionContext(localctx, _startState, CustomAxisParser.RULE_expr);
                    this.state = 47;
                    if (!( this.precpred(this._ctx, 11))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 11)");
                    }
                    this.state = 48;
                    this.match(CustomAxisParser.MULTIPLY_OPERATORS);
                    this.state = 49;
                    this.expr(12);
                    break;

                case 2:
                    localctx = new ExprContext(this, _parentctx, _parentState);
                    this.pushNewRecursionContext(localctx, _startState, CustomAxisParser.RULE_expr);
                    this.state = 50;
                    if (!( this.precpred(this._ctx, 10))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 10)");
                    }
                    this.state = 51;
                    this.match(CustomAxisParser.ADDITION_OPERATORS);
                    this.state = 52;
                    this.expr(11);
                    break;

                } 
            }
            this.state = 57;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,2,this._ctx);
        }

    } catch( error) {
        if(error instanceof antlr4.error.RecognitionException) {
	        localctx.exception = error;
	        this._errHandler.reportError(this, error);
	        this._errHandler.recover(this, error);
	    } else {
	    	throw error;
	    }
    } finally {
        this.unrollRecursionContexts(_parentctx)
    }
    return localctx;
};


function CompletionFunctionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = CustomAxisParser.RULE_completionFunction;
    return this;
}

CompletionFunctionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
CompletionFunctionContext.prototype.constructor = CompletionFunctionContext;

CompletionFunctionContext.prototype.COMPLETION_FUNCTION = function() {
    return this.getToken(CustomAxisParser.COMPLETION_FUNCTION, 0);
};

CompletionFunctionContext.prototype.BEGIN_PARENTHESIS = function() {
    return this.getToken(CustomAxisParser.BEGIN_PARENTHESIS, 0);
};

CompletionFunctionContext.prototype.BEGIN_SUBSTITUTION = function() {
    return this.getToken(CustomAxisParser.BEGIN_SUBSTITUTION, 0);
};

CompletionFunctionContext.prototype.attributeName = function() {
    return this.getTypedRuleContext(AttributeNameContext,0);
};

CompletionFunctionContext.prototype.END_SUBSTITUTION = function() {
    return this.getToken(CustomAxisParser.END_SUBSTITUTION, 0);
};

CompletionFunctionContext.prototype.END_PARENTHESIS = function() {
    return this.getToken(CustomAxisParser.END_PARENTHESIS, 0);
};




CustomAxisParser.CompletionFunctionContext = CompletionFunctionContext;

CustomAxisParser.prototype.completionFunction = function() {

    var localctx = new CompletionFunctionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 4, CustomAxisParser.RULE_completionFunction);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 58;
        this.match(CustomAxisParser.COMPLETION_FUNCTION);
        this.state = 59;
        this.match(CustomAxisParser.BEGIN_PARENTHESIS);
        this.state = 60;
        this.match(CustomAxisParser.BEGIN_SUBSTITUTION);
        this.state = 61;
        this.attributeName();
        this.state = 62;
        this.match(CustomAxisParser.END_SUBSTITUTION);
        this.state = 63;
        this.match(CustomAxisParser.END_PARENTHESIS);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function RunAttributeFunctionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = CustomAxisParser.RULE_runAttributeFunction;
    return this;
}

RunAttributeFunctionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RunAttributeFunctionContext.prototype.constructor = RunAttributeFunctionContext;

RunAttributeFunctionContext.prototype.RUN_ATTRIBUTE_FUNCTION = function() {
    return this.getToken(CustomAxisParser.RUN_ATTRIBUTE_FUNCTION, 0);
};

RunAttributeFunctionContext.prototype.BEGIN_PARENTHESIS = function() {
    return this.getToken(CustomAxisParser.BEGIN_PARENTHESIS, 0);
};

RunAttributeFunctionContext.prototype.BEGIN_SUBSTITUTION = function() {
    return this.getToken(CustomAxisParser.BEGIN_SUBSTITUTION, 0);
};

RunAttributeFunctionContext.prototype.attributeName = function() {
    return this.getTypedRuleContext(AttributeNameContext,0);
};

RunAttributeFunctionContext.prototype.END_SUBSTITUTION = function() {
    return this.getToken(CustomAxisParser.END_SUBSTITUTION, 0);
};

RunAttributeFunctionContext.prototype.END_PARENTHESIS = function() {
    return this.getToken(CustomAxisParser.END_PARENTHESIS, 0);
};

RunAttributeFunctionContext.prototype.COMMA = function() {
    return this.getToken(CustomAxisParser.COMMA, 0);
};

RunAttributeFunctionContext.prototype.runAttributeDefault = function() {
    return this.getTypedRuleContext(RunAttributeDefaultContext,0);
};




CustomAxisParser.RunAttributeFunctionContext = RunAttributeFunctionContext;

CustomAxisParser.prototype.runAttributeFunction = function() {

    var localctx = new RunAttributeFunctionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 6, CustomAxisParser.RULE_runAttributeFunction);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 65;
        this.match(CustomAxisParser.RUN_ATTRIBUTE_FUNCTION);
        this.state = 66;
        this.match(CustomAxisParser.BEGIN_PARENTHESIS);
        this.state = 67;
        this.match(CustomAxisParser.BEGIN_SUBSTITUTION);
        this.state = 68;
        this.attributeName();
        this.state = 69;
        this.match(CustomAxisParser.END_SUBSTITUTION);
        this.state = 72;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===CustomAxisParser.COMMA) {
            this.state = 70;
            this.match(CustomAxisParser.COMMA);
            this.state = 71;
            this.runAttributeDefault();
        }

        this.state = 74;
        this.match(CustomAxisParser.END_PARENTHESIS);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function RunAttributeDefaultContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = CustomAxisParser.RULE_runAttributeDefault;
    return this;
}

RunAttributeDefaultContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
RunAttributeDefaultContext.prototype.constructor = RunAttributeDefaultContext;

RunAttributeDefaultContext.prototype.NUMBER_LITERAL = function() {
    return this.getToken(CustomAxisParser.NUMBER_LITERAL, 0);
};

RunAttributeDefaultContext.prototype.ADDITION_OPERATORS = function() {
    return this.getToken(CustomAxisParser.ADDITION_OPERATORS, 0);
};




CustomAxisParser.RunAttributeDefaultContext = RunAttributeDefaultContext;

CustomAxisParser.prototype.runAttributeDefault = function() {

    var localctx = new RunAttributeDefaultContext(this, this._ctx, this.state);
    this.enterRule(localctx, 8, CustomAxisParser.RULE_runAttributeDefault);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 77;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===CustomAxisParser.ADDITION_OPERATORS) {
            this.state = 76;
            this.match(CustomAxisParser.ADDITION_OPERATORS);
        }

        this.state = 79;
        this.match(CustomAxisParser.NUMBER_LITERAL);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ArgumentListContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = CustomAxisParser.RULE_argumentList;
    return this;
}

ArgumentListContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ArgumentListContext.prototype.constructor = ArgumentListContext;

ArgumentListContext.prototype.expr = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(ExprContext);
    } else {
        return this.getTypedRuleContext(ExprContext,i);
    }
};

ArgumentListContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(CustomAxisParser.COMMA);
    } else {
        return this.getToken(CustomAxisParser.COMMA, i);
    }
};





CustomAxisParser.ArgumentListContext = ArgumentListContext;

CustomAxisParser.prototype.argumentList = function() {

    var localctx = new ArgumentListContext(this, this._ctx, this.state);
    this.enterRule(localctx, 10, CustomAxisParser.RULE_argumentList);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 81;
        this.expr(0);
        this.state = 86;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while(_la===CustomAxisParser.COMMA) {
            this.state = 82;
            this.match(CustomAxisParser.COMMA);
            this.state = 83;
            this.expr(0);
            this.state = 88;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function AttributeNameContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = CustomAxisParser.RULE_attributeName;
    return this;
}

AttributeNameContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
AttributeNameContext.prototype.constructor = AttributeNameContext;

AttributeNameContext.prototype.ATTRIBUTE_NAME = function() {
    return this.getToken(CustomAxisParser.ATTRIBUTE_NAME, 0);
};




CustomAxisParser.AttributeNameContext = AttributeNameContext;

CustomAxisParser.prototype.attributeName = function() {

    var localctx = new AttributeNameContext(this, this._ctx, this.state);
    this.enterRule(localctx, 12, CustomAxisParser.RULE_attributeName);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 89;
        this.match(CustomAxisParser.ATTRIBUTE_NAME);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


CustomAxisParser.prototype.sempred = function(localctx, ruleIndex, predIndex) {
	switch(ruleIndex) {
	case 1:
			return this.expr_sempred(localctx, predIndex);
    default:
        throw "No predicate with index:" + ruleIndex;
   }
};

CustomAxisParser.prototype.expr_sempred = function(localctx, predIndex) {
	switch(predIndex) {
		case 0:
			return this.precpred(this._ctx, 11);
		case 1:
			return this.precpred(this._ctx, 10);
		default:
			throw "No predicate with index:" + predIndex;
	}
};


CustomAxisParser.FormulaContext = FormulaContext;
CustomAxisParser.ExprContext = ExprContext;
CustomAxisParser.CompletionFunctionContext = CompletionFunctionContext;
CustomAxisParser.RunAttributeFunctionContext = RunAttributeFunctionContext;
CustomAxisParser.RunAttributeDefaultContext = RunAttributeDefaultContext;
CustomAxisParser.ArgumentListContext = ArgumentListContext;
export { CustomAxisParser, FormulaContext, ExprContext, CompletionFunctionContext, RunAttributeFunctionContext, RunAttributeDefaultContext, ArgumentListContext, AttributeNameContext };
CustomAxisParser.AttributeNameContext = AttributeNameContext;
